module.exports = __webpack_public_path__ + "media/site/images/tatralife-screen-82535a8be5700c9b2aa8fb713c20184e.jpg";